import LabServiceCollection from "@/collections/LabServiceCollection";
import InstrumentJigModel from "@/models/lab/InstrumentJigModel";

export default class InstrumentJigCollection extends LabServiceCollection {

  model() {
    return InstrumentJigModel;
  }

}
